const StepThree = (props) => (
  <svg
    id="Layer_1"
    viewBox="0 0 447 447"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs id="defs4">
      <style id="style2">
        {
          "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        isolation: isolate;\n      }\n\n      .st2 {\n        display: none;\n      }\n    "
        }
      </style>
    </defs>
    <g id="Layer_2">
      <g id="g23">
        <path
          className="st0"
          d="M357.56,346.94c-4.14,0-7.5,3.36-7.5,7.5v64.15H41.18V28.41h238.06v61.67c0,4.14,3.36,7.5,7.5,7.5h63.32v49.57c0,4.14,3.36,7.5,7.5,7.5s7.5-3.36,7.5-7.5v-57.18c0-2.02-.82-3.96-2.26-5.37L291.97,15.54c-1.4-1.37-3.28-2.13-5.24-2.13H33.68c-4.14,0-7.5,3.36-7.5,7.5v405.18c0,4.14,3.36,7.5,7.5,7.5h323.88c4.14,0,7.5-3.36,7.5-7.5v-71.65c0-4.14-3.36-7.5-7.5-7.5ZM294.24,38.7l45,43.88h-45v-43.88Z"
          id="path9"
        />
        <path
          className="st0"
          d="M64.65,379.09c0,4.14,3.36,7.5,7.5,7.5h247.41c4.14,0,7.5-3.36,7.5-7.5s-3.36-7.5-7.5-7.5H72.15c-4.14,0-7.5,3.36-7.5,7.5Z"
          id="path11"
        />
        <path
          className="st0"
          d="M202.38,324H72.15c-4.14,0-7.5,3.36-7.5,7.5s3.36,7.5,7.5,7.5h130.24c4.14,0,7.5-3.36,7.5-7.5s-3.36-7.5-7.5-7.5h-.01Z"
          id="path13"
        />
        <path
          className="st0"
          d="M258.59,95.38c0-4.14-3.36-7.5-7.5-7.5H72.15c-4.14,0-7.5,3.36-7.5,7.5s3.36,7.5,7.5,7.5h178.94c4.14,0,7.5-3.36,7.5-7.5Z"
          id="path15"
        />
        <path
          className="st0"
          d="M203.12,140.21c0-4.14-3.36-7.5-7.5-7.5h-123.47c-4.14,0-7.5,3.36-7.5,7.5s3.36,7.5,7.5,7.5h123.47c4.14,0,7.5-3.36,7.5-7.5Z"
          id="path17"
        />
        <path
          className="st0"
          d="M72.15,195h92.82c4.14,0,7.5-3.36,7.5-7.5s-3.36-7.5-7.5-7.5h-92.82c-4.14,0-7.5,3.36-7.5,7.5s3.36,7.5,7.5,7.5Z"
          id="path19"
        />
        <path
          className="st0"
          d="M394.03,287.12c3.53,0,6.58-2.46,7.33-5.9l10.07-46.12v-.04l9.22-42.24c.48-2.22-.06-4.54-1.49-6.3-1.42-1.77-3.57-2.8-5.84-2.8h-158.15l-4.72-24.46c-.68-3.53-3.77-6.08-7.36-6.08h-36.47c-4.14,0-7.5,3.36-7.5,7.5s3.36,7.5,7.5,7.5h30.28l4.73,24.52s0,.04,0,.05l8.16,42.3v.04l8.48,43.98c-.01.18-.03.36-.03.55,0,1.18.28,2.3.77,3.29l3.78,19.58c-6.86,3.68-11.54,10.93-11.54,19.24,0,12.03,9.79,21.82,21.82,21.82,10.22,0,18.82-7.06,21.18-16.56h70.91c2.36,9.5,10.96,16.56,21.18,16.56,12.03,0,21.82-9.79,21.82-21.82s-9.79-21.82-21.82-21.82c-8.54,0-15.94,4.93-19.52,12.09h-74.22c-2.92-5.84-8.39-10.19-14.93-11.6l-2.56-13.28h118.91ZM266.23,241.06h33.93l2.74,31.06h-30.68l-5.99-31.06ZM349.93,241.06l-1.57,31.06h-30.4l-2.74-31.06h34.71ZM313.9,226.06l-2.41-27.35h40.58l-1.38,27.35h-36.79ZM387.99,272.12h-24.61l1.57-31.06h29.82l-6.78,31.06h0ZM398.04,226.06h-32.34l1.38-27.35h36.92l-5.97,27.35h.01ZM296.43,198.71l2.41,27.35h-35.5l-5.27-27.35h38.37-.01ZM386.35,314.91c3.77,0,6.82,3.06,6.82,6.82s-3.06,6.82-6.82,6.82-6.82-3.05-6.82-6.82,3.05-6.82,6.82-6.82ZM273.09,328.56c-3.77,0-6.82-3.05-6.82-6.82s3.05-6.82,6.82-6.82,6.82,3.06,6.82,6.82-3.05,6.82-6.82,6.82Z"
          id="path21"
        />
      </g>
    </g>
  </svg>
);
export default StepThree;
